
export { GGUSection } from "/codebuild/output/src3146945838/src/packages/shared-components/src/campaign/GGUSection.tsx"